import React from 'react';

const TridentIcon = ({ className = "w-6 h-6", color = "currentColor" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Center prong */}
      <line x1="12" y1="4" x2="12" y2="22" />
      {/* Left prong */}
      <path d="M7 4 L7 10 L12 12" />
      {/* Right prong */}
      <path d="M17 4 L17 10 L12 12" />
      {/* Top decorative elements */}
      <line x1="7" y1="4" x2="7" y2="2" />
      <line x1="12" y1="4" x2="12" y2="2" />
      <line x1="17" y1="4" x2="17" y2="2" />
      {/* Handle decoration */}
      <circle cx="12" cy="18" r="0.5" fill={color} />
    </svg>
  );
};

export default TridentIcon;